export const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "usecases", label: "Use Cases" },
  { id: "contact", label: "Contact" },
];

export const LINKEDIN_URL = "https://www.linkedin.com/company/episcope-ai";
export const CONTACT_EMAIL = "episcope.ai@gmail.com";

export const COMPAT = [
  { label: "NVIDIA Jetson", kind: "hardware" },
  { label: "AMD Ryzen AI · Instinct", kind: "hardware" },
  { label: "Intel OpenVINO", kind: "hardware" },
  { label: "Qualcomm Dragonwing", kind: "hardware" },
  { label: "Hailo", kind: "hardware" },
  { label: "Raspberry Pi", kind: "hardware" },
  { label: "Rockchip", kind: "hardware" },
  { label: "Axelera", kind: "hardware" },
  { label: "Google Coral", kind: "hardware" },
  { label: "AWS", kind: "cloud" },
  { label: "Microsoft Azure", kind: "cloud" },
  { label: "Google Cloud", kind: "cloud" },
  { label: "Kubernetes", kind: "cloud" },
  { label: "ONVIF", kind: "protocol" },
  { label: "RTSP", kind: "protocol" },
  { label: "WebRTC", kind: "protocol" },
  { label: "HTTP / WebSocket", kind: "protocol" },
  { label: "GenICam", kind: "protocol" },
  { label: "Axis", kind: "camera" },
  { label: "Hikvision", kind: "camera" },
  { label: "Dahua", kind: "camera" },
  { label: "Bosch", kind: "camera" },
  { label: "Milestone XProtect", kind: "camera" },
  { label: "Genetec", kind: "camera" },
  { label: "MQTT / Kafka", kind: "protocol" },
  { label: "YOLO / custom models", kind: "model" },
  { label: "TensorRT", kind: "model" },
  { label: "Private LLMs (Llama, Mistral)", kind: "model" },
  { label: "OpenAI / Azure OpenAI", kind: "model" },
];

export const SERVICES = [
  {
    id: "vision-platform",
    num: "01",
    title: "Vision Platform",
    description:
      "Enterprise-scale AI surveillance with real-time monitoring and predictive analytics. Every camera, every site, one intelligent interface.",
    chips: ["Real-time analytics", "Multi-site", "Cloud · Edge · Hybrid"],
    path: "/vision-platform",
  },
  {
    id: "equip-intelligence",
    num: "02",
    title: "Equip Intelligence",
    description:
      "Modular AI upgrades for the infrastructure you already run. We plug detection, tracking and analytics into existing CCTV, VMS and edge fleets.",
    chips: ["Existing CCTV", "Legacy Jetson fleets", "VMS integrations"],
    path: "/equip-intelligence",
  },
  {
    id: "build-solutions",
    num: "03",
    title: "Build Solutions",
    description:
      "Custom AI ecosystems tailored to your organization's unique challenges, from discovery and data collection to a production model on your hardware.",
    chips: ["Custom models", "LLM & agent layers", "Your hardware"],
    path: "/build-solutions",
  },
];

export const USE_CASES = [
  {
    id: "industrial",
    title: "Industrial Safety",
    image: "/useCases/industrial.jpeg",
    label: "ppe · helmet 0.98",
    description:
      "Real-time PPE detection, hazard-zone monitoring and safety-compliance automation on the plant floor.",
    tags: ["PPE detection", "Hazard zones", "Compliance"],
    size: "xl",
  },
  {
    id: "smart-cities",
    title: "Smart Cities",
    image: "/useCases/smart_cities.jpg",
    label: "vehicle · lane 2 · 0.93",
    description:
      "Traffic and crowd pattern analysis, incident detection and infrastructure optimization across the urban grid.",
    tags: ["Traffic analytics", "Crowd patterns", "Infrastructure"],
    size: "w",
  },
  {
    id: "healthcare",
    title: "Healthcare",
    image: "/useCases/healthcare.jpg",
    label: "patient · fall-risk 0.12",
    description:
      "Patient monitoring, fall detection and surgical-assistance systems that respect privacy by design.",
    tags: ["Patient monitoring", "Surgical assistance"],
    size: "s",
  },
  {
    id: "manufacturing",
    title: "Manufacturing",
    image: "/useCases/manufacturing.jpg",
    label: "defect · scratch 0.87",
    description:
      "Quality-control automation, defect detection and predictive maintenance on the production line.",
    tags: ["Quality control", "Predictive maintenance"],
    size: "s",
  },
  {
    id: "security",
    title: "Security",
    image: "/useCases/surveilance.jpg",
    label: "anomaly · loitering 0.81",
    description:
      "Real-time threat detection, perimeter protection and anomaly monitoring for critical sites.",
    tags: ["Threat detection", "Anomaly monitoring"],
    size: "w",
  },
];

export const PIPELINE = [
  {
    num: "01",
    title: "Ingest",
    icon: "camera",
    description:
      "Connect the cameras you already own. RTSP, ONVIF, WebRTC, HTTP and WebSocket streams from CCTV, IP cameras and IoT sensors.",
    tags: ["RTSP", "ONVIF", "WebRTC"],
  },
  {
    num: "02",
    title: "Detect",
    icon: "scan",
    description:
      "Object detection, segmentation and pose estimation with pretrained or custom-trained models, quantized for your hardware.",
    tags: ["YOLO", "Custom models", "INT8"],
  },
  {
    num: "03",
    title: "Track",
    icon: "radar",
    description:
      "Multi-object tracking with persistent IDs, re-identification across cameras and trajectory history.",
    tags: ["Multi-object", "Re-ID", "Trajectories"],
  },
  {
    num: "04",
    title: "Understand",
    icon: "sparkles",
    description:
      "Zones, dwell time, counting, PPE compliance and anomaly detection turn raw detections into events. Vision-language models let you ask what happened in plain language.",
    tags: ["Zones", "Anomalies", "VLM search"],
  },
  {
    num: "05",
    title: "Act",
    icon: "zap",
    description:
      "Alerts, dashboards and webhooks push events into the tools your teams already use. AI agents can open tickets, notify people and close the loop.",
    tags: ["Alerts", "API", "AI agents"],
  },
];

export const INTEL_PROMPTS = [
  {
    q: "Any PPE violations in Zone B this shift?",
    answer:
      "Three events between 06:40 and 11:15. Two missing-helmet detections near press line 2 (06:42 and 09:58) and one missing high-vis vest at the loading bay (11:15). All three were acknowledged by the shift lead within four minutes.",
    events: [
      { t: "06:42", cam: "CAM-07", what: "helmet missing", conf: "0.94" },
      { t: "09:58", cam: "CAM-07", what: "helmet missing", conf: "0.91" },
      { t: "11:15", cam: "CAM-12", what: "vest missing", conf: "0.88" },
    ],
    actions: ["Draft incident report", "Notify safety lead", "Add to weekly review"],
  },
  {
    q: "Which gate had the longest truck queue today?",
    answer:
      "Gate C. It peaked at nine trucks between 14:05 and 14:40 with an average wait of 23 minutes, right after the weighbridge went idle at 13:50. Gates A and B stayed under four trucks all day.",
    events: [
      { t: "13:50", cam: "CAM-03", what: "weighbridge idle 40 min", conf: "0.96" },
      { t: "14:05", cam: "CAM-03", what: "queue length 9", conf: "0.93" },
      { t: "14:40", cam: "CAM-03", what: "queue cleared", conf: "0.95" },
    ],
    actions: ["Open maintenance ticket", "Send summary to logistics", "Alert if queue > 6"],
  },
  {
    q: "Summarise last night's perimeter alerts.",
    answer:
      "Eleven alerts, two worth your attention: a person loitering at the north fence for six minutes at 02:14, and a vehicle stopping on the service road at 03:40. The remaining nine were animals and headlight glare and were auto-dismissed.",
    events: [
      { t: "02:14", cam: "CAM-21", what: "loitering 6 min", conf: "0.87" },
      { t: "03:40", cam: "CAM-19", what: "vehicle stopped", conf: "0.91" },
      { t: "night", cam: "9 cams", what: "auto-dismissed (animals, glare)", conf: "—" },
    ],
    actions: ["Export clips to security", "Create incident", "Tune fence-zone sensitivity"],
  },
];

export const INTEL_FEATURES = [
  {
    icon: "sparkles",
    title: "Ask in plain language",
    text: "Vision-language models index what your cameras saw, so anyone can search footage and ask questions without scrubbing through timelines.",
    chips: ["VLM search", "Q&A over video", "Natural-language rules"],
  },
  {
    icon: "activity",
    title: "Reports that write themselves",
    text: "Large language models turn the day's events into shift summaries, incident narratives and compliance logs, each linked back to the clip.",
    chips: ["Shift reports", "Incident narratives", "Audit trails"],
  },
  {
    icon: "zap",
    title: "Agents that act",
    text: "AI agents open tickets, notify the right person, escalate and close the loop, inside guardrails you define and with a human in the loop where it matters.",
    chips: ["Slack / Teams", "Jira / ServiceNow", "Webhooks & API", "Approvals"],
  },
];

export const INTEGRATIONS = [
  {
    title: "Cameras & streams",
    lead: "Standard protocols first, so any camera you already own can be connected.",
    items: [
      "RTSP / RTSPS",
      "ONVIF Profile S · T · M",
      "WebRTC",
      "SRT",
      "GenICam / GigE Vision",
      "USB / MIPI-CSI",
      "HTTP snapshots & MJPEG",
      "WebSocket events",
    ],
  },
  {
    title: "Video management & data",
    lead: "Plug into the VMS and the data platforms your operation already runs.",
    items: [
      "Milestone XProtect",
      "Genetec Security Center",
      "Network Optix / Hanwha WAVE",
      "Axis Camera Station",
      "MQTT",
      "Apache Kafka",
      "OPC UA (industrial)",
      "REST API & webhooks",
    ],
  },
  {
    title: "Security & identity",
    lead: "Built to pass an enterprise security review, on-prem or in your cloud.",
    items: [
      "TLS everywhere",
      "mTLS device identity",
      "WireGuard / VPN tunnels",
      "SSO (SAML / OIDC, Entra ID)",
      "Role-based access & audit logs",
      "Data retention & GDPR controls",
      "Air-gapped / on-prem option",
    ],
  },
];
